import { Store } from '../root';
import { IQuoteResponse } from '@joc/api-gateway';

export const selectorGetQuotesAll = (store: Store): Array<IQuoteResponse> => {
	return store.quotesRedux.quotesRecords;
};
